module.exports = __webpack_public_path__ + "img/bot.da0d4707.jpg";